module.exports = __webpack_public_path__ + "static/media/de_inferno.875d5ec3.svg";